import { render, staticRenderFns } from "./physio-chiro-osteo.vue?vue&type=template&id=2841f407&"
import script from "./physio-chiro-osteo.vue?vue&type=script&lang=js&"
export * from "./physio-chiro-osteo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports